<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { get_gen_2_component_channel_structure, real_id } from 'src/helpers/interface_helpers';
		import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { Alert, Button, Select, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);
	const component = get_gen_2_component_channel_structure(device);

	const INPUT_OPTIONS = [
		{ value: 0, i18nKey: 'raex_inputs_dual_button_reverse', fallback: 'Dual button reverse' },
		{
			value: 1,
			i18nKey: 'raex_inputs_momentary_rocker_switch',
			fallback: 'Momentary rocker switch',
		},
		{ value: 2, i18nKey: 'raex_inputs_triple_button', fallback: 'Triple button' },
		{ value: 3, i18nKey: 'raex_inputs_dual_button', fallback: 'Dual button' },
	];

	let settings = $settingsStore;
	let currentValue = settings?.[component]?.motor?.sw_ctrl ?? 0;
	let selected = currentValue;
	let cache = currentValue;
	let loading = false;

	const options = INPUT_OPTIONS.map((opt) => ({
		value: opt.value,
		title:
			$format(opt.i18nKey, {
				default: opt.fallback,
			}) || opt.fallback,
	}));

	const handleChange = (value: number) => {
		selected = Number(value);
	};

	const save = async () => {
		if (selected === cache) return;

		loading = true;

		const params = {
			id: device.channel ?? 0,
			config: {
				motor: {
					sw_ctrl: selected,
				},
			},
		};

		const res: SettingRequest = await gen2Request(device, 'Cover.SetConfig', params);

		if (res.isok) {
			if (!settings[component].motor) {
				settings[component].motor = {};
			}
			settings[component].motor.sw_ctrl = selected;
			devices_settings.update_devices_settings(id, settings);
			cache = selected;
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast', { default: 'Settings saved' }),
			});
		} else {
			selected = cache;
			toast.open({ type: 'danger', title: $format('error_global') });
		}

		loading = false;
	};
</script>

<Alert
	type="info"
	heading={$format('raex_inputs_configuration_info_heading', { default: 'Inputs configuration' })}
	isHeadingBold
	message={$format('raex_inputs_configuration_info_body', {
		default:
			'Dual button reverse: Press one button to open the cover and the other one to close it. During movement, if the same button is pressed, the cover stops. Releasing the switch stops the action. Triple-button mode: One button for Open, one for Stop, one for Close. Dual button: Press one button to open the cover. Press the any button or to stop it.',
	})}
	class="mb-s"
/>

<Select
	size="m"
	width="full"
	icon="fas fa-cog"
	{options}
	value={options.find((opt) => opt.value === selected) || options[0]}
	on:change={(e) => handleChange(e.detail['value'])}
	id="select-raex-inputs-configuration"
	aria-label={$format('raex_inputs_configuration_title', { default: 'Inputs configuration' })}
/>

<Button class="mt-s" {loading} size="m" width="full" on:click={save}>
	{$format('button_save')}
</Button>
